import apiServices from 'config/apiServiceApiGateway'
import type {
  GetNonLoginTypesResponseType,
  GetAATestMetricsResponseType,
  GetAATestMetricResultsResponseType,
  PostAATestPayloadType,
  PostAATestResultPayloadType,
  PutStartExperimentResponseType,
  PutStartExperimentLoginRequestPayloadType,
  PutStopExperimentResponseType,
} from 'features/ABAdmin/@types/ExperimentAddEdit'
import {
  type GetExperimentByIdResponseType,
  type PostPutExperimentPayloadType,
} from 'utils/apiList/abtesting'

const { Get, Post, Put } = apiServices

export const getNonLoginExperimentTypes = () =>
  Get<GetNonLoginTypesResponseType>({
    url: '/abtesting/internal/:version/non_login/experiment/type',
    version: 'v1',
  })

export const getNonLoginExperimentById = (experimentId: number) =>
  Get<GetExperimentByIdResponseType, true>({
    url: '/abtesting/internal/:version/non_login/experiment/:experimentId',
    version: 'v1',
    urlParams: { experimentId },
  })

export const postNonLoginExperiment = (data: PostPutExperimentPayloadType) =>
  Post<{ id: number }>({
    url: '/abtesting/internal/:version/non_login/experiment',
    version: 'v1',
    data,
  })

export const putNonLoginExperiment = (experimentId: number, data: PostPutExperimentPayloadType) =>
  Put({
    url: '/abtesting/internal/:version/non_login/experiment/:experimentId',
    version: 'v1',
    urlParams: { experimentId },
    data,
  })

export const putStartNonLoginExperiment = (experimentId: number) =>
  Put<PutStartExperimentResponseType>({
    url: '/abtesting/internal/:version/non_login/experiment/:experimentId/start',
    version: 'v1',
    urlParams: { experimentId },
  })

export const putStopNonLoginExperiment = (experimentId: number) =>
  Put<PutStopExperimentResponseType>({
    url: '/abtesting/internal/:version/non_login/experiment/:experimentId/stop',
    version: 'v1',
    urlParams: { experimentId },
  })

// AA Test
export const getAATestMetrics = () =>
  Get<GetAATestMetricsResponseType>({
    url: '/abtesting/internal/:version/aa-testing/metric',
    version: 'v1',
  })

export const getAATestMetricResults = (experimentId: number) =>
  Get<GetAATestMetricResultsResponseType>({
    url: '/abtesting/internal/:version/aa-testing/:experimentId/result',
    version: 'v1',
    urlParams: { experimentId },
  })

export const postAATest = (experimentId: number, data: PostAATestPayloadType) =>
  Post<{ success: boolean; experiment_id: number }>({
    url: '/abtesting/internal/:version/aa-testing/:experimentId/start',
    version: 'v1',
    urlParams: { experimentId },
    data,
  })

export const postAATestResult = (experimentId: number, data: PostAATestResultPayloadType) =>
  Post<{ success: boolean; experiment_id: number }>({
    url: '/abtesting/internal/:version/aa-testing/:experimentId/result',
    version: 'v1',
    urlParams: { experimentId },
    data,
  })

// experiment login
export const putStartExperimentLogin = (
  experimentId: number,
  payload: PutStartExperimentLoginRequestPayloadType,
) =>
  Put<PutStartExperimentResponseType>({
    url: '/abtesting/internal/v1/experiment/:experimentId/start',
    urlParams: {
      experimentId,
    },
    data: payload,
  })

export const putStopExperimentLogin = (experimentId: number) =>
  Put<PutStopExperimentResponseType>({
    url: '/abtesting/internal/v1/experiment/:experimentId/stop',
    urlParams: {
      experimentId,
    },
  })

export const putPauseExperiment = (experimentId: number) =>
  Put<PutStopExperimentResponseType>({
    url: '/abtesting/internal/v1/experiment/:experimentId/pause',
    urlParams: {
      experimentId,
    },
  })

export const putResumeExperiment = (experimentId: number) =>
  Put<PutStopExperimentResponseType>({
    url: '/abtesting/internal/v1/experiment/:experimentId/resume',
    urlParams: {
      experimentId,
    },
  })
